const dashboard = {
  totalPatients: 'Pacientes totales',
  newPatients: 'Nuevos pacientes',
  criticalPatients: 'Pacientes críticos',
  abnormalPatients: 'Pacientes anormales',
  activePatients: 'Pacientes activas',
  inactivePatients: 'Pacientes inactivas',
  todayAppointment: "Cita de hoy",
  careCoordinatorStats: 'Coordinadora de Cuidados Estadísticas',
  cPTCodeBillingSummary: 'Resumen de facturación del código CPT',
  financialStats: 'Estadísticas financieras',
  totalPatientsChart: 'Gráfico de pacientes totales',
  appointmentSummary: 'Resumen de la cita',
  newPatientsChart:'Tabla de nuevas pacientes'
}


export default dashboard
